module.exports = __webpack_public_path__ + "img/AI人脸.20913461.png";